import { useState, FC } from 'react';
import { PaymentMethodType, setPaymentMethod } from '@store/slices/order';
import { useAppDispatch, useAppSelector } from '@hooks/redux-custom';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Grid, Typography } from '@mui/material';
import visa from './CardLogos/visa.png';
import amex from './CardLogos/amex.png';
import paypal from './CardLogos/paypal.png';
import master from './CardLogos/mastercard.png';

type Props = {
  methods: PaymentMethodType[];
};

enum PaymentMethods {
  PAYPAL = 'paypal',
  CARD = 'card',
}

const PaymentMethod: FC<Props> = ({ methods }) => {
  const order = useAppSelector((state) => state.order.value);
  const dispatch = useAppDispatch();
  const [selectedCard, setSelectedCard] = useState(order.selectedPaymentMethod?.id || '');

  const logos: any = {
    visa: visa,
    amex: amex,
    paypal: paypal,
    mastercard: master,
  };

  const heights: any = {
    visa: '50px',
    amex: '50px',
    paypal: '60px',
    mastercard: '55px',
  };

  const paymentLogo = (p: PaymentMethodType) => {
    switch (p.method) {
      case PaymentMethods.CARD:
        return p.scheme ? (
          <img src={logos[p.scheme?.toLowerCase()]} alt={p.id} style={{ height: heights[p.scheme.toLowerCase()] }} />
        ) : null;
      case PaymentMethods.PAYPAL:
        return <img src={logos[p.scheme.toLowerCase()]} alt={p.id} style={{ height: heights[p.scheme.toLowerCase()] }} />;
      default:
        return null;
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedCard((event.target as HTMLInputElement).value);

    // if card set paymentMethod as item else noCharge
    if (event.target.value !== 'noCharge') {
      const item = methods.find((item) => item.id === event.target.value);

      dispatch(setPaymentMethod(item));
    } else {
      dispatch(
        setPaymentMethod({
          id: 'noCharge',
        }),
      );
    }
  };

  if (!order.products.length) return <></>;

  return (
    <FormControl
      fullWidth
      data-testid="payment-form"
      style={{
        padding: '10px 0',
      }}
    >
      <Typography variant="h5" mx={1}>
        Payment options:{' '}
      </Typography>
      <RadioGroup onChange={handleChange} value={selectedCard}>
        {methods?.map((item) => (
          <FormControlLabel
            key={item.id}
            value={item.id}
            control={<Radio />}
            style={{
              border: `1px solid ${selectedCard === item.id ? '#c59deb' : '#ddd'}`,
              padding: '10px',
              margin: '5px',
              borderRadius: '5px',
              width: '100%',
              background: `${selectedCard === item.id ? '#cd9bf021' : '#fff'}`,
            }}
            label={
              <Grid container spacing={3}>
                <Grid item xs={4} textAlign="center">
                  {paymentLogo(item)}
                </Grid>
                <Grid item alignItems="center" display="flex" xs={8}>
                  {item?.label && (
                    <Typography variant="subtitle1" fontSize={20}>
                      **** **** **** {item.label}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            }
          />
        ))}
        <FormControlLabel
          value="noCharge"
          control={<Radio />}
          style={{
            border: `1px solid ${selectedCard === 'noCharge' ? '#c59deb' : '#ddd'}`,
            padding: '10px',
            margin: '2px',
            borderRadius: '5px',
            background: `${selectedCard === 'noCharge' ? '#cd9bf021' : '#fff'}`,
          }}
          label={
            <Grid container spacing={3} p={2}>
              <Grid item display={'flex'} sx={{ flexDirection: 'column' }} alignItems={'flex-end'}>
                <Typography>No Charge</Typography>
              </Grid>
            </Grid>
          }
        />
      </RadioGroup>
    </FormControl>
  );
};

export default PaymentMethod;
